<div class="field">
    <div class="flex flex-row"> <p-dropdown *ngIf="hasFormControl(phoneCodeControlName)" class="flex-grow-1"
            [style]="{ 'border-top-right-radius': '0', 'border-bottom-right-radius': '0'}" [options]="countries"
            optionLabel="phoneCode" optionValue="phoneCode" appendTo="body" [filter]="true" filterBy="name"
            [formControl]="getFormControl(phoneCodeControlName)!" (onChange)="onCountryChange($event)"
            (onBlur)="onBlur()">
            <ng-template pTemplate="item" let-country>
                {{ country.emoji }} {{ country.name }} +{{country.phoneCode}}
            </ng-template>
            <ng-template pTemplate="selectedItem" let-selectedCountry>
                <span *ngIf="getSelectedCountry()">
                    {{ getSelectedCountry()?.emoji }} +{{ getSelectedCountry()?.phoneCode }}
                </span>
            </ng-template>
        </p-dropdown>

        <input *ngIf="hasFormControl(phoneNumberControlName)" class="flex-grow-3" [id]="inputId"
            [style]="{'border-left': 'none', 'border-top-left-radius': '0', 'border-bottom-left-radius': '0'}"
            pInputText [formControl]="getFormControl(phoneNumberControlName)!" [placeholder]="placeholder"
            (input)="onPhoneNumberChange($event)" (blur)="onBlur()" />
    </div>
</div>